<template>
  <a-modal
    v-model:open="openLocal"
    :footer="null"
    :width="578"
    centered
    :maskClosable="true"
    class="hubspot-export-modal"
  >
    <!-- Header / contenido -->
    <div class="hubspot-export-modal__content">
      <!-- Logo -->
      <div class="hubspot-export-modal__logo">
        <HubspotLogo class="hs-select__icon" width="110" height="32" />
      </div>

      <!-- Título -->
      <a-typography-title :level="3" class="hubspot-export-modal__title">
        Exporta tus contactos de BeexCC a <br/> HubSpot
      </a-typography-title>

      <!-- Subtítulo -->
      <span class="hubspot-export-modal__subtitle">
        Todo contacto creado desde BeexCC podrá ser exportado a HubSpot. Considera los siguientes puntos:
      </span>

      <!-- Dos columnas -->
      <a-row :gutter="[24, 24]" class="hubspot-export-modal__grid">
        <a-col :xs="24" :md="12">
          <div class="hubspot-export-modal__block">
            <div class="hubspot-export-modal__mock">
              <img :src="HubspotMassExport" alt="" />
            </div>

            <h3 :level="5" class="hubspot-export-modal__blockTitle">
              Exportación masiva
            </h3>

            <span class="hubspot-export-modal__blockText">
              Selecciona tus contactos y desde las acciones masivas haz clic en 
              <span class="bold">“Exportar a HubSpot”.</span>
            </span>
          </div>
        </a-col>

        <a-col :xs="24" :md="12">
          <div class="hubspot-export-modal__block">
            <div class="hubspot-export-modal__mock">
              <img :src="HubspotIndividualExport" alt="" />
            </div>

            <h3 :level="5" class="hubspot-export-modal__blockTitle">
              Exportación individual
            </h3>

            <span class="hubspot-export-modal__blockText">
              Desde las acciones individuales o los detalles del contacto, haz clic en 
              <span class="bold">“Exportar a HubSpot”.</span>
            </span>
          </div>
        </a-col>
      </a-row>

      <!-- Nota inferior -->
      <a-alert
        class="hubspot-export-modal__note"
        type="info"
        show-icon
        :message="noteText"
      />
    </div>
  </a-modal>
</template>

<script setup lang="ts">
import { computed } from "vue";
import HubspotIndividualExport from "@/app/integrations/assets/HubspotIndividualExport.png?url";
import HubspotMassExport from  "@/app/integrations/assets/HubspotMassExport.png?url";
import HubspotLogo from "@/app/integrations/components/icons/HubspotLogo.vue";

const props = defineProps<{
  open: boolean;
  noteText?: string;
}>();

const emit = defineEmits<{
  (e: "update:open", value: boolean): void;
}>();

const openLocal = computed({
  get: () => props.open,
  set: (v: boolean) => emit("update:open", v),
});

const noteText = computed(
  () =>
    props.noteText ??
    "Recuerda que solo se exportarán los datos de columnas homologadas con HubSpot en las plantillas de contactos y el teléfono añadido más reciente."
);
</script>

<style scoped lang="sass">
:deep(.hubspot-export-modal .ant-modal-content)
  border-radius: 18px
  padding: 26px 26px 22px

:deep(.hubspot-export-modal .ant-modal-close)
  top: 14px
  right: 14px

.hubspot-export-modal__content
  text-align: center
  padding: 30px 25px

.hubspot-export-modal__logo
  display: flex
  justify-content: center
  margin-bottom: 10px

.hubspot-export-modal__title
  margin: 12px 0 !important
  font-weight: 600
  font-size: 24px
  color: #262626E0

.hubspot-export-modal__subtitle
  display: inline-block
  // max-width: 560px
  margin-bottom: 10px
  line-height: 1.45
  color: $gray-8

.hubspot-export-modal__grid
  margin-top: 10px
  margin-bottom: 16px
  text-align: left

.hubspot-export-modal__block
  display: flex
  flex-direction: column
  gap: 5px

.hubspot-export-modal__mock
  background: #fff
  /* border: 1px solid #f0f0f0 */
  /* border-radius: 12px */
  /* padding: 10px */
  display: flex
  justify-content: center
  align-items: center

:deep(.hubspot-export-modal__mock img)
  width: 100%
  height: auto
  border-radius: 10px
  margin-bottom: 10px
  border: 1px solid $gray-4

.hubspot-export-modal__blockTitle
  margin: 0 !important
  font-weight: 600
  color: #262626E0

.hubspot-export-modal__blockText
  line-height: 1.5
  color: $gray-8

.bold
  font-weight: 500

/* Nota inferior tipo “card” */
.hubspot-export-modal__note
  text-align: left
  border-radius: 12px
  padding: 10px 14px
  color: #262626E0 !important

:deep(.hubspot-export-modal__note .ant-alert-message)
  line-height: 1.45
</style>
